<!-- Liste des configurations Travel Hub -->
<ng-container *ngIf="listeTravelHub; else loading">
    <list-view [liste]="listeTravelHub"></list-view>
    <floating-button [listeActions]="listeActions"></floating-button>
</ng-container>

<!-- Écran de chargement -->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>